import { defineCopy } from '@floorfile/i18n'
import { partsCopy } from './copy'

export const partsOfflineCopy = defineCopy('parts', { offlineAction: partsCopy.en.offlineAction })
